import styled from 'styled-components';

import login from '../../img/login.jpg';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;

  input {
    margin-bottom: 3rem;
    height: 2rem;
    padding: 0 0.5rem;
    border: 1px solid #ddd;
    width: 90%;
  }

  button {
    width: 90%;
    background-color: #024089;
  }
  `;

export const Logo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem 0rem 3rem 0rem;
`;

export const PlanoDeFundo = styled.div`
  background-image: url(${login});
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  height: 100vh;
  display: flex;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
`;

export const Container = styled.div`
  width: 24rem;
  height: 30rem;
  margin: 5rem auto;
  background: #ffffff;
  padding: 1rem;
  border-radius: 10px;

  h1 {
    display: flex;
    align-items: baseline;
    margin: 1rem 0rem 2rem  1.2rem;
  }
`;
